import React from 'react';

export const Makes = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <h3 style={{ fontSize: '62px' }}>Our Brand Family</h3>
      <div className="header-container">
        {[
          204, 212, 221, 225, 234, 244, 342, 374, 375, 376, 377, 378, 379, 380,
          381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394,
          395, 396, 397, 398, 399, 400, 401, 402,
        ].map((group) => {
          return (
            <div className="dealership-container">
              <img
                style={{ objectFit: 'contain', background: '#ffffff' }}
                src={require(`../../assets/RideNow Home Page - OEM Brands/Group ${group}.png`)}
                width={'80%'}
                height={'80%'}
                // onClick={() => window.open(dealership.url, '_black')}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
